var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM8 10.6745C5.63922 10.6745 3.81961 11.5137 3.02745 12.4549C1.97647 11.2784 1.34118 9.71765 1.34118 8C1.34118 4.30588 4.2902 1.33333 7.99216 1.33333C11.6863 1.33333 14.6588 4.30588 14.6667 8C14.6667 9.72549 14.0314 11.2863 12.9725 12.4627C12.1804 11.5216 10.3608 10.6745 8 10.6745ZM8 9.34118C6.48627 9.32549 5.31765 8.07059 5.3098 6.38431C5.29412 4.8 6.49412 3.48235 8 3.48235C9.49804 3.48235 10.6902 4.8 10.6902 6.38431C10.6902 8.07059 9.50588 9.35686 8 9.34118Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Profile.62352e72e5f398374d368ed9cbcfb893.svg";